export default __webpack_public_path__ + "images/d341c2ec0c32865b24e5f2c38b999eaf-holiday.webp";